import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent, IonButton, IonIcon, IonRouterOutlet, IonMenu, IonMenuToggle, IonAvatar, IonList, IonItem, IonLabel, IonActionSheet, IonItemGroup, IonItemDivider, IonRouterLink, IonModal, IonFooter, IonInput, IonBackButton, IonInputPasswordToggle, IonSpinner, IonToggle, IonTextarea, IonInfiniteScroll, IonInfiniteScrollContent, IonToast, IonBackdrop, IonPopover, IonListHeader
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core'
import { ChatDatePipe } from './pipes/chat-date.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe'

const IONIC_COMPONENTS = [
    IonHeader, IonToolbar, IonTitle, IonButtons,
    IonMenuButton, IonContent, IonButton, IonIcon,
    IonRouterOutlet, IonMenu, IonAvatar,
    IonMenuToggle, IonList, IonItem, IonLabel, IonActionSheet,
    IonItemGroup, IonItemDivider, IonRouterLink, IonModal, IonFooter, IonInput,
    IonBackButton, IonInputPasswordToggle, IonSpinner, IonToggle, IonTextarea,
    IonInfiniteScroll, IonInfiniteScrollContent, IonToast, IonBackdrop, IonPopover, IonListHeader
];

@NgModule({
    imports: [
        ...IONIC_COMPONENTS,
        CommonModule,
        TranslateModule,
        ChatDatePipe,
        StripHtmlPipe
    ],
    exports: [
        ...IONIC_COMPONENTS,
        CommonModule,
        TranslateModule,
        ChatDatePipe,
        StripHtmlPipe
    ]
})

export class IonicSharedModule {
}
